module.exports = __webpack_public_path__ + "img/3symbol.27cf05d6.svg";